<template>
  <footer class="footer">
    <div class="footer__grid">
      <!-- 品牌区 -->
      <div class="footer__brand">
        <img :src="logoSrc" alt="YWG" class="footer__logo" />
        <p class="footer__desc">
          广东省南方文化产权交易所官方平台。以矩阵式方式承接文化产权、交易服务与地方文化礼赠展示。
        </p>
        <p class="footer__copyright">
          © 2026 粤文购 版权所有 | 粤ICP备11002111号
        </p>
      </div>

      <!-- 右侧区 -->
      <div class="footer__links">
        <!-- 业务入口 -->
        <div class="footer__col">
          <h4 class="footer__col-title">业务入口</h4>
          <div class="footer__col-content">
            <span
              v-for="item in navLinks"
              :key="item.name"
              class="footer__link"
              @click="onNavigate(item.name)"
            >
              {{ item.label }}
            </span>
          </div>
        </div>

        <!-- 联系与合作 -->
        <div class="footer__col">
          <h4 class="footer__col-title">联系与合作</h4>
          <div class="footer__col-content">
            <span>contact@yuewengou.cn</span>
            <span>020-0000-0000</span>
            <span>广州 · 官方合作咨询入口</span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import logoSrc from "@/assets/images/YWG_logo03.png";

export default {
  name: "Footer",
  data() {
    return {
      logoSrc,
      navLinks: [
        { name: "Home", label: "首页" },
        { name: "CulturalMall", label: "南方文化商城" },
        { name: "ArtTrade", label: "艺术品交易" },
        { name: "Gift", label: "广东礼物" },
        { name: "Heritage", label: "数遗光年" },
      ],
    };
  },
  methods: {
    onNavigate(name) {
      if (this.$route.name !== name) {
        this.$router.push({ name });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.footer {
  background-color: #0e2746;
  padding: 40px;
  height: $footer-height;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  &__grid {
    display: flex;
    justify-content: space-between;
    height: 100%;
    max-width: 1440px;
    flex: 1;
  }

  // ---- 品牌区 ----
  &__brand {
    width: 430px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__logo {
    width: 129px;
    height: 38px;
    object-fit: contain;
  }

  &__desc {
    font-size: $font-size-nav;
    color: #ffffffb8;
    line-height: 1.74;
    margin: 0;
    text-align: left;
  }

  &__copyright {
    font-size: $font-size-nav;
    color: #ffffffb8;
    line-height: 1.74;
    margin: 0;
    text-align: left;
  }

  // ---- 右侧区 ----
  &__links {
    width: 490px;
    display: flex;
    gap: 22px;
    justify-content: flex-end;
  }

  &__col {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }

  &__col-title {
    font-size: $font-size-label;
    font-weight: normal;
    color: #d7c08f;
    letter-spacing: 1.2px;
    margin: 0;
  }

  &__col-content {
    display: flex;
    flex-direction: column;
    gap: 0;
    align-items: flex-start;
  }

  &__link {
    font-size: $font-size-nav;
    color: #ffffff;
    line-height: 1.84;
    cursor: pointer;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.8;
    }
  }

  &__col-content span {
    font-size: $font-size-nav;
    color: #ffffff;
    line-height: 1.84;
  }

  // ---- 平板适配 ----
  @include tablet {
    padding: 32px;

    .footer__brand {
      width: 340px;
    }

    .footer__links {
      width: 400px;
      gap: 18px;
    }
  }

  // ---- 手机适配 ----
  @include mobile {
    height: auto;
    padding: 40px 20px;

    .footer__grid {
      flex-direction: column;
      gap: 40px;
    }

    .footer__brand {
      width: 100%;
    }

    .footer__links {
      width: 100%;
      justify-content: space-between;
    }

    .footer__link {
      display: flex;
      align-items: center;
    }

    .footer__col-content span {
      display: flex;
      align-items: center;
    }
  }
}
</style>
